import styled from "styled-components";

const ImageA4Root = styled.div`
  height: 948.66px;
`;

export default ImageA4Root;
